import { cn } from "@patient-watch/ui/utils";
import { LucideIcon } from "lucide-react";

interface GradientIconProps {
    icon: LucideIcon;
    theme: string;
    className?: string;
    isLoading?: boolean;
}

const blue = {
    hard: "from-blue-200 via-indigo-200 to-purple-200",
    soft: "from-blue-400/30 via-indigo-400/30 to-purple-400/30",
    text: "text-blue-600",
};
const green = {
    hard: "from-green-200 via-emerald-200 to-teal-200",
    soft: "from-green-400/30 via-emerald-400/30 to-teal-400/30",
    text: "text-green-600",
};
const amber = {
    hard: "from-orange-200 via-amber-200 to-yellow-200",
    soft: "from-orange-400/30 via-amber-400/30 to-yellow-400/30",
    text: "text-orange-600",
};
const pink = {
    hard: "from-pink-200 via-rose-200 to-purple-200",
    soft: "from-pink-400/30 via-rose-400/30 to-purple-400/30",
    text: "text-pink-600",
};
const purple = {
    hard: "from-purple-200 via-pink-200 to-indigo-200",
    soft: "from-purple-400/30 via-pink-400/30 to-indigo-400/30",
    text: "text-purple-600",
};

const themes = {
    blue,
    green,
    amber,
    pink,
    purple,
};

export function GradientIcon({ icon: Icon, theme, className, isLoading }: GradientIconProps) {
    const colors = themes[theme as keyof typeof themes] || themes.green;

    return (
        <div className={`relative rounded-[min(20px,5vw)] w-[min(200px,35vw)] aspect-square ${className}`}>
            <div
                className={cn(
                    `absolute inset-0 bg-gradient-to-br shadow-lg border border-white/20 rounded-[1rem]`,
                    colors.hard
                )}
            />
            <div className="absolute inset-0 bg-gradient-to-br from-white/50 to-transparent rounded-[1rem]" />
            <div className="absolute inset-0 flex justify-center items-center">
                <div className="relative">
                    <div className={cn("absolute inset-0 bg-gradient-to-br blur-xl", colors.soft)} />
                    <Icon
                        className={cn(`relative drop-shadow-lg w-16 h-16`, colors.text, isLoading && "animate-spin")}
                    />
                </div>
            </div>
        </div>
    );
}
